import "./StudentHeader.css";
import { Hidden, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { RootState } from "../../state/configureStore";
import AppHeader from "../AppHeader";

const StudentHeader = () => {
  const currentUser = useSelector((state: RootState) => state.currentUserState.currentUser);
  return (
    <AppHeader className="StudentHeader">
      <Hidden xsDown>
        <Typography variant="h6">
          <p className="headerText">Hi, {currentUser?.displayName}!</p>
        </Typography>
      </Hidden>
    </AppHeader>
  );
};

export default StudentHeader;
